<template>
  <section class="section comments-section">
    <h3 class="title is-size-2 is-size-4-touch has-text-centered">
      What people say
    </h3>
    <br />
    <div
      v-for="comment in comments"
      :key="comment.id"
      class="columns is-centered"
    >
      <div class="column is-8 is-size-4 is-size-6-touch">
        <Quote :text="comment.text" :author="comment.username" />
      </div>
    </div>
  </section>
</template>

<script>
import Quote from "./Quote";

export default {
  components: { Quote },
  data() {
    return {
      comments: [
        {
          id: 3,
          text: "This is brilliant. I like it a lot!",
          username: "yosetime59 (Reddit user)"
        },
        {
          id: 1,
          text:
            "I've been trying it and it's awesome! Some people might feel that reading a whole paragraph could be a little overwhelming, but I think it helps me to link many sentences together without sounding \"weird\".",
          username: "Mariachi_dude (Reddit user)"
        },
        {
          id: 2,
          text:
            "I was looking for exactly a tool like this to practice my pronunciation. Thanks a bunch for creating this!",
          username: "het1709 (Reddit user)"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.reddit-comment {
  margin: 0 auto;
}
</style>
